// Espaciados consistentes
export const SPACING = {
  xs: '0.25rem',   // 4px
  sm: '0.5rem',    // 8px
  md: '1rem',      // 16px
  lg: '1.5rem',    // 24px
  xl: '2rem',      // 32px
  xxl: '4rem',     // 64px
  xxxl: '5rem',    // 80px
};

export default SPACING;
